import { render, staticRenderFns } from "./jobs.vue?vue&type=template&id=24f9e3e2&"
import script from "./jobs.vue?vue&type=script&lang=js&"
export * from "./jobs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/servers/jobs.vue
// module id = null
// module chunks = 